export enum LoadingProgress {
    LOADING = 'loading',
    LOADED = 'loaded',
    ERROR = 'error'
}